import React, { FC } from 'react';
import Border, { IBorderValueProps } from '../../../puck/reusable-props/Border';
import { MarginType } from '../../../puck/reusable-props/NewMargin';
import { PaddingType } from '../../../puck/reusable-props/padding';
import PaddingComponent from '../../customComponents/PaddingComponent';
import { FieldLabel } from '@measured/puck';
import CustomTooltip from '../../../../components/common/tooltip';
import { Select } from '../../form-fields/Select';
import { heightOptions } from '../../../puck/reusable-props/height';
import { boxShadows } from '../../../puck/reusable-props/options';
import WithAccordion from '../../customComponents/CustomAccordion';
import { widthOptions } from '../../../puck/reusable-props/width';
import NewMarginFiled from '../../../puck/reusable-props/newMarginField';

export interface ButtonComponentProps {
  border: IBorderValueProps;
  margin: MarginType;
  padding: PaddingType;
  boxShadow: 'none' | 'shadow-md' | 'shadow-lg' | 'shadow-xl' | 'shadow-2xl';
  height: string;
  width: string;
}

interface IButtonComponentProps {
  value: ButtonComponentProps;
  onChange: (_value: ButtonComponentProps) => void;
  title?: string;
}

const ButtonComponent: FC<IButtonComponentProps> = ({
  value,
  onChange,
  title = 'Button',
}) => {
  return (
    <WithAccordion title={title}>
      <NewMarginFiled
        value={value?.margin}
        onChange={margin => {
          onChange({ ...value, margin });
        }}
        title="Margin"
      />
      <PaddingComponent
        value={value?.padding}
        onChange={padding => {
          onChange({ ...value, padding });
        }}
        title="Padding"
      />
      <Border
        value={value?.border}
        onChange={border => {
          onChange({ ...value, border });
        }}
        title="Border"
      />
      <FieldLabel
        label={
          (
            <CustomTooltip title="fontWeight">
              <span>Height</span>
            </CustomTooltip>
          ) as React.ReactNode as string
        }
        el="div">
        <Select
          value={value?.height}
          onChange={event =>
            onChange({
              ...value,
              height: event.target.value,
            })
          }
          options={heightOptions}
        />
      </FieldLabel>
      <FieldLabel
        label={
          (
            <CustomTooltip title="fontWeight">
              <span>Width</span>
            </CustomTooltip>
          ) as React.ReactNode as string
        }
        el="div">
        <Select
          value={value?.width}
          onChange={event =>
            onChange({
              ...value,
              width: event.target.value,
            })
          }
          options={widthOptions}
        />
      </FieldLabel>
      <FieldLabel
        label={
          (
            <CustomTooltip title="fontWeight">
              <span>Box Shadow</span>
            </CustomTooltip>
          ) as React.ReactNode as string
        }
        el="div">
        <Select
          value={value?.boxShadow}
          onChange={event =>
            onChange({
              ...value,
              boxShadow: event.target.value as
                | 'none'
                | 'shadow-md'
                | 'shadow-lg'
                | 'shadow-xl'
                | 'shadow-2xl',
            })
          }
          options={boxShadows}
        />
      </FieldLabel>
    </WithAccordion>
  );
};

export default ButtonComponent;
